import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import Loader from "../Chargers/Loader";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import { fetchStatusList } from "../../Apis/StatusListing";
import { useNavigate } from "react-router-dom";


function Withdrawal() {
  document.title = "Withdrawal";

  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedLimit, setselectedLimit] = useState("");
  const [Limit, setLimit] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");

  const [selectedUser, setSelectedUser] = useState('');
  const [selectedPaymentChange, setSelectedPaymentChange]  = useState('');
  const [TotalPayments, setTotalPayments] = useState("");

  
let navigate = useNavigate();


const handleReset = (event) => {
  event.preventDefault()
 navigate(`/withdrawals`);
  }

  // Helper function for handling the select box change
   const handlePaymentChange = (e) => {
    setSelectedPaymentChange(e.target.value);
    // Optional: handle any additional logic, such as API calls to update status
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  // Fetch Stations Data without search filter
  const FetchStationsData = async (currentPage, searchTerm = '') => {
    setLoading(true);
    const url = `${BaseURL}/razorpay/withdraw-list/?page=${page}&searchText=${searchTerm}&payment_status=${selectedStatus}`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        // setStationData(res.data.data);
        setFilteredData(res.data.data);
        setTotalCount(res.data?.totalCount || 0);
        setLimit(res?.data?.limit);
        setPageCount(Math.ceil(res.data.totalCount / res?.data?.limit));
        setTotalPayments(res?.data?.totalAmount)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(page, searchQuery); // Pass current page and search query to the fetch function
  }, [page,]);

  // Handle input change in search field
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };





  // Handle submit to fetch filtered data
  const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Check if the search query is empty
    if (!searchQuery.trim()) {
      // If no search query, call FetchStationsData to fetch all stations
      await FetchStationsData(page); // Ensure this function fetches all stations
      return; // Exit the function early
    }

    setLoading(true); // Set loading state to true while fetching

    const url = `${BaseURL}/razorpay/withdraw-list?searchText=${searchQuery}&payment_status=${selectedStatus}`;

    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });

      if (res && res.data && res.data.data) {
        setFilteredData(res.data.data);
        setTotalCount(res.data.data.length); // Update totalCount with filtered data count
        setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on total count and limit
      } else {
        setFilteredData([]); // If no data is returned, set filtered data to empty
        setTotalCount(0); // Update total count to 0 when no data is found
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false); // Set loading state to false after fetching
    }
  };

    console.log("Limit", Limit);
  const handleStatus = (e) => {
    setSelectedStatus(e.target.value);
  }
  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // URL for the updated endpoint
    const url = `${BaseURL}/razorpay/withdraw-change-status`;
  
    // Create JSON payload with withdraw_status and user_withdrawl_id
    const statusData = {
      withdraw_status: status, // Send the updated status
      user_withdrawl_id: userId, // Send the userId as the withdrawal ID
    };
  
    try {
      // Send the request with updated data
      const response = await axios.post(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Ensure it's sent as JSON
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
  
        // Update local state on success
        setUserStatuses((prevStatuses) => ({
          ...prevStatuses,
          [userId]: status,
        }));
      } else {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: response.data.message,
          showConfirmButton: true,
        });
  
        // Reset the dropdown to the previous value on error
        setUserStatuses((prevStatuses) => ({
          ...prevStatuses,
          [userId]: prevStatuses[userId] || "",
        }));
      }
    } catch (error) {
      console.error("Error updating status:", error);
  
      // Handle the error response
      if (error.response && error.response.data && error.response.data.message) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.message, // Display error message from the server
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An unexpected error occurred. Please try again later.",
          showConfirmButton: true,
        });
      }
  
      // Reset the dropdown to the previous value on error
      setUserStatuses((prevStatuses) => ({
        ...prevStatuses,
        [userId]: prevStatuses[userId] || "",
      }));
    }
  };
  
  
  console.log("withdrawlllllllllDataaaaa", filteredData);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header pb-0">
              

            <div>
  <div className="row align-items-center">
    {/* Left Section */}
    <div className="col-6 d-flex align-items-center" style={{ gap: "10px" }}>
      <h5 className="mb-0">
        All Withdrawal Payments ({totalCount ? totalCount : "Loading..."})
      </h5>
      <button
        className="btn btn-success"
        style={{
          height: "38px",
          borderRadius: "34px",
          padding: "0 20px",
        }}
      >
        Total Withdrawal Payment: {TotalPayments}
      </button>
    </div>

    {/* Right Section */}
    <div className="col-6 d-flex justify-content-end align-items-center" style={{ gap: "10px" }}>
      <form onSubmit={handleSearchSubmit} className="d-flex align-items-center">
        <input
          placeholder="Find Data Here"
          className="form-control"
          style={{
            width: "100%",
            maxWidth: "170px",
            border: "1px solid black",
            borderRadius: "34px",
            height: "38px",
          }}
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <select
          className="form-control"
          style={{
            width: "100%",
            maxWidth: "150px",
            border: "1px solid black",
            borderRadius: "34px",
            height: "38px",
          }}
          onChange={handleStatus}
        >
          <option value="">Select Status</option>
          <option value="Pending">Pending</option>
          <option value="Approved">Approved</option>
          <option value="Rejected">Rejected</option>
          <option value="Completed">Completed</option>
        </select>
        <button
          type="submit"
          className="btn btn-primary"
          style={{
            height: "38px",
            padding: "0 20px",
            borderRadius: "34px",
          }}
        >
          Search
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          style={{
            height: "38px",
            padding: "0 20px",
            borderRadius: "34px",
          }}
          onClick={handleReset}
        >
          Reset
        </button>
      </form>
    </div>
  </div>
</div>

              <hr/>
            </div>
            <div className="card-body">
              {loading ? (
                <Loader />
              ) : (
                <div className="card-body" style={{ marginLeft: "-19px" }}>
                  {loading ? (
                <h1>No data Found</h1>
                  ) : (
                    <>
                      <div className="table-responsive">

                        <table className="display dataTable" id="advance-1">
                          <thead>
                            <tr>
                              <th>Sr. No</th>
                              <th>Account Number</th>
                              <th>Bank</th>
                              <th>Account Holder Name</th>
                              <th>Mobile Number</th>
                              <th>IFSC Code</th>
                              <th>Amount</th>
                              <th>payment Status</th>
                              <th>Title</th>
                              <th>WithdrawalID</th>
                             
                              <th>Created Date</th>
                              <th>Updated Date</th>
</tr>
                          </thead>
                          <tbody>
                            {filteredData?.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-center">No Data Available</td>
                              </tr>
                            ) : (
                              filteredData?.map((u, index) => (
                                <tr key={index}>
                                  <td>{(page - 1) * Limit + index + 1}</td>
                                  <td>{u?.bankAccounts?.account_number}</td>
                                  <td>{u?.bankAccounts?.bank_name}</td>
                                  <td>{u?.bankAccounts?.account_holder_name}</td>
                                  <td>{u?.bankAccounts?.mobile_number}</td>
                                  <td>{u?.bankAccounts?.ifsc_code}</td>
                                  <td>{u?.amount}</td>
                                  <td>      <select
              onChange={(e) => handleStatusType(e, u._id)}
              value={userStatuses[u._id] || u.withdraw_status} 
              className="custom-select"
              id="statusType"
              name="statusType"
            >
        <option value="">Payment Status</option>
        <option value="Pending">Pending</option>
         <option value="Approved">Approved</option>
        <option value="Rejected">Rejected</option>
        <option value="Completed">Completed</option>
      </select>
                                  </td>
                                  <td>{u?.title}</td>
                                  <td>{u?.withdrawId}</td>
                                 
                                  <td>{u?.createdAt}</td>
                                  <td>{u?.updatedAt}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>

                      </div>

                      <div className="pagination-container mt-4">
                        <ReactPaginate
                          previousLabel={'Previous'}
                          nextLabel={'Next'}
                          breakLabel={'...'}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName={'pagination'}
                          subContainerClassName={'pages pagination'}
                          activeClassName={'active'}
                          forcePage={page - 1}
                        />
                      </div>
                    </>
                  )}
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdrawal;
